module.exports = __webpack_public_path__ + "img/Lost.784e0ec4.svg";